import store from '@/store/index'

export function checkAuth(akses) {
  if (!akses) return false
  const level = store.getters['auth/getData']?.Level
  if (akses.includes(level)) return true
  return false
}
